import React, { useContext } from 'react';
import { Text, View } from 'react-native';
import { Button } from '@rneui/themed';
import FontAwesome5 from '@expo/vector-icons/FontAwesome5';
import PropTypes from 'prop-types';
import { H3, H5, Paragraph } from '../text';
import CdnImage from '../common/CdnImage';
import ComponentContainer from '../common/ComponentContainer';
import LayoutContext from '../../contexts/Layout';

const TextPlusImageWithLink = ({
    description,
    followContentLink,
    heading,
    image,
    link,
    linkText,
    nodeTypeAlias = 'TextPlusImageWithLink',
    references,
    webOnly,
    hardWidth
}) => {
    const IMAGE_PERCENT = 0.34;
    const TEXT_PERCENT = 1 - IMAGE_PERCENT;

    const { layout } = useContext(LayoutContext);
    const flexDirection = layout.device.isMobile || layout.device.isTablet ? 'column' : 'row';
    const imageWidth = layout.device.isMobile || layout.device.isTablet ? hardWidth : Math.floor(hardWidth * IMAGE_PERCENT);
    const textWidth = layout.device.isMobile || layout.device.isTablet ? undefined : Math.floor(hardWidth * TEXT_PERCENT);

    if (!layout.device.os.equals('web') && webOnly) {
        return null;
    }

    return (
        <View
            style={{ flexDirection: flexDirection, marginBottom: layout.styleGuide.componentSeparator }}
            dataSet={{ umbracoComponentName: nodeTypeAlias, spacerBottom: `StyleGuide.ComponentSeparator(${layout.styleGuide.componentSeparator})` }}
        >
            <CdnImage
                alt={heading}
                uri={image.cdnImagePath}
                height={layout.device.isNative ? hardWidth : '100%'}
                width={imageWidth}
                wrapperStyle={layout.isMobile && { flex: IMAGE_PERCENT }}
                style={{ marginRight: layout.styleGuide.spacer7 }}
                dataSet={{ spacerRight: `StyleGuide.Spacer7(${layout.styleGuide.spacer7})` }}
            />
            <ComponentContainer style={{ ...{ flex: 1 }, ...{ backgroundColor: '#fff', justifyContent: 'center', width: textWidth } }}>
                <H3
                    style={{ marginVertical: layout.styleGuide.spacer2 }}
                    text={heading}
                    dataSet={{ spacerLeft: `StyleGuide.Spacer2(${layout.styleGuide.spacer2})`, spacerRight: `StyleGuide.Spacer2(${layout.styleGuide.spacer2})` }}
                />
                <View style={{ marginHorizontal: layout.device.isNative ? 10 : undefined }}>
                    <Paragraph
                        wrapperStyle={{ width: undefined }}
                        extraStyle={{ marginBottom: layout.styleGuide.spacer3 }}
                        text={description}
                        dataSet={{ spacerBottom: `StyleGuide.Spacer3(${layout.styleGuide.spacer3})` }}
                    />
                    <Button
                        buttonStyle={{ paddingLeft: 0 }}
                        containerStyle={{ flexDirection: 'row', justifyContent: 'flex-start' }}
                        icon={<FontAwesome5 color='#153d6e' name='chevron-circle-right' size={20} style={{ marginLeft: 5 }} />}
                        iconRight={true}
                        onPress={async () => await followContentLink(link.isExternal, link.internalKey, link.externalUrl, references)}
                        title={<H5 style={{ color: '#153d6e' }} text={linkText} />}
                        type='clear'
                    />
                </View>
            </ComponentContainer>
        </View>
    );
};

TextPlusImageWithLink.propTypes = {
    image: PropTypes.shape({
        cdnImagePage: PropTypes.string
    }),
    heading: PropTypes.string,
    description: PropTypes.string,
    linkText: PropTypes.string,
    link: PropTypes.shape({
        externalUrl: PropTypes.string,
        isExternal: PropTypes.bool,
        internalKey: PropTypes.string
    }),
    webOnly: PropTypes.bool
};

export default TextPlusImageWithLink;
